(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list/assets/javascripts/game.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list/assets/javascripts/game.js');

'use strict';

const {
  resolveProductId
} = svs.utils.products;
const {
  clx
} = svs.components.lbUtils;
const {
  ReactIcon
} = svs.ui;
const {
  FavoriteBadge
} = svs.components.marketplace.gameList;
const {
  games: gameHelpers
} = svs.components.marketplace.helpers;
const {
  GameTypeTag
} = svs.components.marketplace.gameTypeTag;
const {
  RibbonBanner
} = svs.ui.ReactRibbon;
const {
  MarketplaceBrand
} = svs.components.marketplace.marketplaceBrand;
const {
  getStatusDesc
} = svs.components.marketplace.helpers.games;
const {
  format
} = svs.utils;
const {
  showFewSharesLeftRibbon
} = svs.components.marketplace.helpers.games;
const {
  useEffect,
  useRef
} = React;
const Game = _ref => {
  let {
    children,
    className,
    game,
    groupId,
    isRetail,
    LinkComponent,
    productName,
    shouldScrollTo = false
  } = _ref;
  const {
    activatedDrawId,
    fractionPrice,
    status: gameStatus,
    isAllowedToSubmit,
    isFavorite,
    name,
    preliminaryRowExists,
    soldShares,
    subProductId
  } = game;
  const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);
  const productId = resolveProductId(productName);
  const gameTag = gameHelpers.getSubProductTag(productId, subProductId);
  const showGameTag = gameTag && isRetail;
  const el = useRef();
  const showFewSharesLeft = showFewSharesLeftRibbon(game, groupId);
  const classNames = clx('game-container', className, {
    'few-shares-left': showFewSharesLeft
  });
  const gameStatusDesc = getStatusDesc(gameStatus, isAllowedToSubmit, preliminaryRowExists);
  const WrapContentWithLink = _ref2 => {
    let {
      children
    } = _ref2;
    if (LinkComponent) {
      return React.createElement(LinkComponent, null, React.createElement("div", {
        "aria-hidden": "true",
        className: classNames,
        "data-testid": "qa-game"
      }, children));
    }
    return React.createElement("div", {
      "aria-hidden": "true",
      className: classNames,
      "data-testid": "qa-game"
    }, children);
  };
  useEffect(() => {
    if (shouldScrollTo) {
      svs.components.Storage.browser.get('lastClickedGame', 'marketplace', data => {
        if (data && data.activatedDrawId && data.activatedDrawId === activatedDrawId && el.current) {
          el.current.scrollIntoView({
            behavior: 'instant',
            block: 'center'
          });
          svs.components.Storage.browser.set('lastClickedGame', 'marketplace', null);
        }
      });
    }
  }, []);
  return React.createElement(WrapContentWithLink, null, isFavorite && React.createElement(FavoriteBadge, null), React.createElement("div", {
    className: "game-wrapper ".concat(showGameTag ? 'game-type-tag-height' : '')
  }, showFewSharesLeft && React.createElement(RibbonBanner, {
    direction: "right",
    size: "200"
  }, "F\xE5 andelar kvar!"), React.createElement("div", {
    className: "game-container-brand"
  }, React.createElement("i", {
    className: "game-icon"
  }, React.createElement(MarketplaceBrand, {
    productId: productId,
    square: true,
    subProductId: subProductId || null
  }))), React.createElement("div", {
    className: "game-status"
  }, showGameTag && React.createElement(GameTypeTag, {
    productId: productId,
    subProductId: subProductId
  }), React.createElement("div", {
    className: "f-medium f-600"
  }, React.createElement("div", {
    className: "game-title".concat(showFewSharesLeft ? '-shortened' : ''),
    ref: el
  }, name ? capitalizeFirstLetter(name) : '-'), preliminaryRowExists && React.createElement("div", {
    className: "preliminary-row-icon"
  }, React.createElement(ReactIcon, {
    icon: "overview",
    size: "100"
  }))), children)), React.createElement("div", {
    className: "game-status-desc-container"
  }, React.createElement("div", {
    className: "game-status-desc"
  }, isAllowedToSubmit && React.createElement("div", {
    className: "game-status-fractions"
  }, "Laget har ".concat(format.Currency(fractionPrice * soldShares), " kr att spela f\xF6r")), gameStatusDesc && React.createElement("div", {
    className: "fc-red",
    "data-testid": "qa-game-status-text"
  }, gameStatusDesc))));
};
setGlobal('svs.components.marketplace.gameList.Game', Game);

 })(window);